import { Component, Input } from '@angular/core';

@Component({
    selector: 'sl-loader',
    templateUrl: './sl-loader.component.html',
    styleUrls: ['./sl-loader.component.scss'],
    standalone: true
})
export class SlLoaderComponent {
    @Input() small = false;
    @Input() light = false;
}
